"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compileEnum = exports.pick = void 0;
const getEnumKey = (e, v) => {
    const entry = Object.entries(e).find((e) => e[1] === v);
    if (!entry) {
        throw new Error('Vale not present in enum');
    }
    return entry[0];
};
const pick = (e, v) => e[getEnumKey(e, v)];
exports.pick = pick;
const compileEnum = (e, name) => `(?<${name}>${Object.values(e).join('|')})`;
exports.compileEnum = compileEnum;
//# sourceMappingURL=utils.js.map